var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.4,
    height: 16.404,
    viewBox: "0 0 16.4 16.404",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconmonstr-save-lined",
    transform: "translate(0.2 0.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-save-lined-2",
    "data-name": "iconmonstr-save-lined",
    d: "M5.892,3.139a.6.6,0,1,1,.617,1.029,6.8,6.8,0,1,0,6.985,0,.6.6,0,1,1,.619-1.029,8,8,0,1,1-8.22,0Zm.665,6.867s1.62,1.617,3.024,3.02a.6.6,0,0,0,.849,0l3.024-3.021a.6.6,0,0,0-.848-.849l-2,2V2.6a.6.6,0,1,0-1.2,0v8.557l-2-2a.6.6,0,0,0-.843,0,.6.6,0,0,0-.178.425.59.59,0,0,0,.172.419Z",
    transform: "translate(-2 -2)",
    fill: "#16161a",
    stroke: "#16161a",
    strokeWidth: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.a1a15563b7a6761a1196791e2dfb0755.svg";
export { ForwardRef as ReactComponent };